import {Component} from "@angular/core";

@Component({
  selector: "common-i18nselectpipe",
  template: `
  <usecase-container title="I18nSelectPipe" src="common/i18nselectpipe">
    <usecase-content>
      <p>{{gender | i18nSelect: genderMapping}}</p>
      <select [(ngModel)]="gender">
        <option *ngFor="let g of genders" [value]="g">{{g}}</option>
      </select>
    </usecase-content>
  </usecase-container>
    `,
})
export class I18nSelectPipeComponent {
  private genders = ["male", "female", "other"];
  private gender = this.genders[1];

  private genderMapping: any = {
    "male": "Who is him?",
    "female": "Who is her?",
    "other": "Who are them?"
  };
}



/** WEBPACK FOOTER **
 ** ./script/common/i18nselectpipe/component.ts
 **/